import React from 'react';
import '../../../static/scss/components/ui/formError.scss';

type Props = {
  error: ?string
};

const FormError = ({ error }: Props) => {
  if (!error) {
    return null;
  }

  return <span className="c-form-error">{error}</span>;
};

export default FormError;
